import * as R from 'ramda'
import { SET_ENTITIES } from 'actions'

const subscriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_ENTITIES: {
      return R.merge(state, action.entities.subscription)
    }
    default:
      return state
  }
}

export default subscriptionReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/subscription/index.js